import * as React from "react";
import { formatBuildingAddress } from "src/helpers/formatBuildingAddress";
import style from "./Header.scss";
import Icon from "@elsa-zku/lib/components/Icon/Icon";
import Dropdown, { DropdownChildrenRenderProps } from "@elsa-zku/lib/components/Dropdown/Dropdown";
import Button from "@elsa-zku/lib/components/Button/Button";
import { createComponentModalOpener } from "@elsa-zku/lib/components/Modals/helpers/modalOpener";
import { useSelectedBuilding } from "src/store/buildings";
import { unauth, useUser } from "src/store/user";

const openBuildingSelect = createComponentModalOpener(React.lazy(() => import('src/components/BuildingSelectPopup')))

type Props = {};

const Header: React.FC<Props> = (props) => {
  const {} = props;
  const selectedBuilding = useSelectedBuilding();
  const { email } = useUser();

  const onOpenSelect = () => openBuildingSelect({
    size:           1100,
    rawBody:        true,
    componentProps: {},
  }, { hideClose: true });

  const renderProfile = (props: DropdownChildrenRenderProps) => {
    return (

      <button className={style.user} onClick={props.onActivate}>
        <div className={style.name}>{email}</div>
        <div className={style.settingsButton} ref={props.elementRef}>
          <Icon className={style.settingsIcon} icon={require('@elsa-zku/lib/icons/Settings.svg')} />
        </div>
      </button>
    );
  }

  const renderProfileDropdown = () => {
    return (
      <>
        <Button outline icon={require('feather-icons/dist/icons/log-out.svg')} onClick={unauth}>
          Выход
        </Button>
      </>
    );
  }

  return (
    <div className={style.container}>
      {selectedBuilding && (
        <>
          <button className={style.button} onClick={onOpenSelect}>
            <div className={style.company}>{selectedBuilding.company_name}</div>
            <div className={style.buttonText}>
              <div className={style.address}>
                {formatBuildingAddress(selectedBuilding)}
              </div>
              <Icon className={style.icon} icon={require('feather-icons/dist/icons/chevron-down.svg')} />
            </div>
          </button>

        </>
      )}
      <div className={style.aside}>
        <div className={style.tp}>
          <Button outline size="sm" tag="a" href="https://myelsa.kaiten.ru/sd/requests" target="_blank">
            Написать в техподдержку
          </Button>
        </div>
        <Dropdown renderDropdown={renderProfileDropdown} dropdownClassName={style.profileDropdown}>
          {renderProfile}
        </Dropdown>
      </div>
    </div>
  )
};

export default React.memo(Header);
